<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Firma Profili</h3>
          </div>
          <div>
            <div
              class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push"
              m-dropdown-toggle="hover"
              aria-expanded="true"
            >
              <a
                href="#"
                class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill m-dropdown__toggle"
              >
                <i class="la la-plus m--hide"></i>
                <i class="la la-ellipsis-h"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  

 
    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/tenants'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Firma Profili
                  </h3>
                </div>
              </div>
            </div>
                         
            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">

                    <div class="large-12 medium-12 small-12 cell">
                      <div id="app">
  <img :src="companyPictureSrc" alt="">
</div>
<div class="form-group m-form__group row">
  <div class="col-lg-12">
 <label>File</label>
  <input type="file" id="file" ref="file" class="form-control" v-on:change="handleFileUpload()"/>
      <!-- <button v-on:click="submitFile()" class="srcbtn">Yükle</button>  -->
 
  </div>
</div>
        </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Kod</label>
                    <input type="text"  :class="{ 'is-invalid': $v.item.code.$error }" v-model="item.code" class="form-control m-input" placeholder="Müşteri kodu giriniz." />
                  </div>
                </div>
              
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Ad</label>
                    <input type="text"  :class="{ 'is-invalid': $v.item.name.$error }" v-model="item.name" class="form-control m-input" placeholder="Müşteri Adı giriniz." />
                  </div>
                </div>
 <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Açıklama</label>
                    <textarea class="form-control m-input" v-model="item.description" placeholder="Açıklama giriniz." id="exampleTextarea" rows="3"></textarea>
                  </div>
                </div>
 
  

              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="item.id==0?create():update()" class="spbtn">KAYDET</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>  
            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.srcbtn{
    background-color: #008CBA; 
    border: none;
    border-radius:5px;
    font-weight: bold;
    color: white;
    padding:6px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
  }
  .srcbtn:hover{
    background-color: #0DABB3;
  }
</style>

<script>
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import {_getMyTenantInfo,_update,_uploadFile,_getTenantPicture} from '../../services/TenantService'

export default {
created() {
  this.getMyTenantInfo();
},
   data() {
    return {
      item:{
        id:0,
        code:'',
        name:'',
        description:'',
        companyPicturePath:'',
       companyPictureFileName:'',
      } ,
      companyPictureInfo : {
        folderName:'',
       fileName:''

      },
companyPictureFile: '',
       companyPictureStream : null,
       companyPictureSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"

    }

  },
    validations: {
    item: {
      code: { required },
           name: { required}
    }
  },
methods: {
  handleFileUpload(){
    this.companyPictureFile = this.$refs.file.files[0];
     _uploadFile(this.companyPictureFile).then(response => {
        if(response.data.success)
        {
          this.companyPictureInfo = response.data.data;
          this.item.companyPicturePath = this.companyPictureInfo.folderName;
          this.item.companyPictureFileName = this.companyPictureInfo.fileName;
          this.update();

        }
    });
  },
  // submitFile(){  
  //   _uploadFile(this.companyPictureFile).then(response => {
  //       if(response.data.success)
  //       {
  //         this.companyPictureInfo = response.data.data;
  //         this.item.companyPicturePath = this.companyPictureInfo.folderName;
  //         this.item.companyPictureFileName = this.companyPictureInfo.fileName;
  //         this.update();

  //       }
  //   });

  //     },
  update:function(){
          this.$v.item.$touch();
      if (this.$v.item.$error) return;
    _update(this.item).then(response=>{
      if(response.data.success)
        this.getMyTenantInfo();
    });
  } ,
  getTenantPicture: function()
  {
    if (this.item.companyPicturePath != '')
    {
    _getTenantPicture(this.item).then(response => {
    if(response.data.success)
        {
                  this.companyPictureSrc =response.data.data;
        }
    
    
    });
    }
  },
  getMyTenantInfo:function(){
      _getMyTenantInfo().then(response=>{
        
      if(response.data.success)
      {
      this.item=response.data.data;
       if (this.item.companyPictureFileName!=''  )
       {
       // this.getTenantPicture(this.item)
       }
      }
      else
      this.$router.push({ name: 'notifications' })
  })
  },
  }
};
</script>